// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__gVE0m","button":"styles_button__7LVYh","text-area":"styles_text-area__6zRUo"};